import type { BrandDetails } from "./types/brand.types";

/**
 * The practice's address as one line: the street, then where it is.
 *
 * Each part only if it is there, so a brand with a city and nothing else
 * reads as a city rather than as a row of commas.
 *
 * Its own file because two screens now write this line and they must not
 * disagree: the Details tab shows it back, and the Schedule dialog seeds an
 * in-person appointment's address with it. A second copy is a second set of
 * commas to get wrong.
 */
export const brandAddressLine = (details: BrandDetails): string =>
  [details.address, details.city, details.state, details.pincode]
    .map((part) => part?.trim() ?? "")
    .filter(Boolean)
    .join(", ");

export default brandAddressLine;
